import { WeeebflowCollection } from "./weeebflow/collection";

function _loader() {
  let baseUrl = "http://localhost:1234";
  let px = document.createElement("img");
  let pxSrc = `${baseUrl}/assets/px.jpg`;

  px.src = pxSrc;

  px.onload = () => {
    px.remove();
    console.log("🟣 weeebflow.p.js: _loader(): Local instance");

    window.__PEEL_LOCAL__ = true;

    var localJs = document.createElement("script");
    localJs.setAttribute("type", "text/javascript");
    localJs.setAttribute("async", "async");
    localJs.src = `${baseUrl}/weeebflow.p.js`;

    document.body.appendChild(localJs);
  };

  px.onerror = () => {
    px.remove();
    console.log("🟢 weeebflow.p.js: _loader(): Prod instance");

    window[`__PEEL_INST__`] = new WeeebflowCollection();
  };

  document.body.appendChild(px);
}

if (!window.__PEEL_LOCAL__) {
  _loader();
} else {
  window[`__PEEL_INST__`] = new WeeebflowCollection();
}

addEventListener("popstate", () => {
  console.log("popstate => WeeebflowCollection._loader()");

  if (window[`__PEEL_INST__`]) {
    window[`__PEEL_INST__`].init();
  } else {
    _loader();
  }
});
